export const statesData = [
  {
    id: 1,
    countryName: 'AmericanSamoa(+684)',
    img: 'assets/admin/img/flags/us.png',
    countryCode: 'AS',
    stateName: 'SwainsIsland',
    Action: '',
  },
  {
    id: 2,
    countryName: 'Andorra(+376)',
    img: 'assets/admin/img/flags/ad.png',
    countryCode: 'AD',
    stateName: 'SwainsIsland',
    Action: '',
  },

  {
    id: 3,
    countryName: 'Angola(+244)',
    img: 'assets/admin/img/flags/ao.png',
    countryCode: 'AO',
    stateName: 'Benguela',
    Action: '',
  },
  {
    id: 4,
    countryName: 'Anguilla(+1264)',
    img: 'assets/admin/img/flags/ai.png',
    countryCode: 'AI',
    stateName: 'TheValley',
    Action: '',
  },
  {
    id: 5,
    countryName: 'Antarctica(+672)',
    img: 'assets/admin/img/flags/qa.png',
    countryCode: 'AQ',
    stateName: 'VictoriaLand',
    Action: '',
  },
  {
    id: 6,
    countryName: 'Antigua&Barbuda(+1268)',
    img: 'assets/admin/img/flags/ag.png',
    countryCode: 'AG',
    stateName: 'SaintPaul',
    Action: '',
  },
  {
    id: 7,
    countryName: 'Argentina(+54)',
    img: 'assets/admin/img/flags/ar.png',

    countryCode: 'AR',
    stateName: 'SantaFe',
    Action: '',
  },
  {
    id: 8,
    countryName: 'Australia(+61)',
    img: 'assets/admin/img/flags/au.png',

    countryCode: 'AU',
    stateName: 'Queensland',
    Action: '',
  },
];
